import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-edit-business',
  templateUrl: './edit-business.component.html',
  styleUrl: './edit-business.component.scss'
})
export class EditBusinessComponent {
 businessId!: number | null;

  constructor(private route: ActivatedRoute) {}
  ngOnInit(): void {
    this.businessId =Number(this.route.parent?.snapshot.paramMap.get('id'));
  }
}
